module.exports = "<div fxFlexFill fxLayoutAlign=\"center center\" class=\"icon-pointer\">\n  <mat-icon>pageview</mat-icon>\n</div>"